class SearchFilter extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.list = this.querySelector('ul');
        if (!this.input) return
        this.filterItems = this.filterItems.bind(this);
        this.input.addEventListener('keyup', this.filterItems);
    }
    filterItems() {
        this.list.querySelectorAll('li').forEach(item => {
            const text = item.textContent.toLowerCase();
            const matches = text.includes(this.input.value.toLowerCase());
            item.style.display = matches ? '' : 'none';
        });
    }
    disconnectedCallback() {
        this.input.removeEventListener('input', this.filterItems);
    }
}
customElements.define('search-filter', SearchFilter);
